export const extractFileNameUrl = (url) => (url ? url.split("/")[url.split("/").length - 1] : "");
